// src/hooks/useJournalContext.js
//
// Opt-in only: when users/{uid}.journalShareWithCoach is true, subscribe to
// the member's own journal and return a compact summary string for the AI
// Coach. Returns null otherwise — no listener is even opened.

import { useEffect, useState } from 'react';
import { subscribeJournal, summarizeJournalForCoach } from '../utils/journalStore';
import { PREVIEW_UID } from '../utils/guidedPath';

export const useJournalContext = (currentUser, isPreviewMode = false) => {
    const optIn = !!currentUser?.journalShareWithCoach && !isPreviewMode; // preview never shares
    const uid = optIn ? currentUser?.uid : null;
    const [context, setContext] = useState(null);

    useEffect(() => {
        if (!uid || uid === PREVIEW_UID) { setContext(null); return undefined; }
        const unsub = subscribeJournal(uid, (entries) => {
            setContext(entries.length ? summarizeJournalForCoach(entries) : null);
        });
        return () => unsub();
    }, [uid]);

    return optIn ? context : null;
};

export default useJournalContext;
